import React from 'react';
import BrandLogo from '../BrandLogo';
import { APP_NAME } from '../../config/appConfig';

const AuthShowcase = ({
  platformLabel,
  kicker,
  title,
  description,
  features,
  variant = 'customer',
}) => {
  const isDriver = variant === 'driver';

  return (
    <div className={`auth-showcase ${isDriver ? 'driver-showcase' : ''}`}>
      <div className={`auth-brand-lockup ${isDriver ? 'auth-brand-lockup-driver' : ''}`}>
        <BrandLogo className="auth-brand-icon" />
        <div className="auth-brand-copy">
          <strong>{APP_NAME}</strong>
          <small>{platformLabel}</small>
        </div>
      </div>
      <span className="auth-kicker">{kicker}</span>
      <h1>{title}</h1>
      <p>{description}</p>
      <div className="auth-feature-list">
        {features.map((feature) => (
          <div className="auth-feature-item" key={feature.title}>
            <strong>{feature.title}</strong>
            <span>{feature.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuthShowcase;
